import { EthSafeTransaction } from '@safe-global/protocol-kit'

export interface TransactionHistoryItem {
  tx: EthSafeTransaction
  hash: string
  type?: string
  safeAddress: string
  executionDate: string | null
  transactionHash: string | null
  isSuccessful: boolean | null
  executor: string | null
  amount?: string
  to?: string
}

export interface PendingTransaction {
  tx: EthSafeTransaction
  hash: string
  isReady?: boolean
  type?: string
  safeAddress?: string
  createdDate?: string
}

export interface TransactionFilters {
  executionDateFrom?: string
  executionDateTo?: string
  nonce?: string
  type?: string
}

export enum TransactionType {
  Mint = 'mint',
  Burn = 'burn',
  Transfer = 'transfer',
  Delete = 'removeOperationalSafe',
  Block = 'pauseSafe',
  Unblock = 'unpauseSafe',
}

export enum DateRangeOption {
  Last30Days = '30',
  Last6Months = '180',
  Last12Months = '365',
  Custom = 'custom',
}

export const TRANSACTION_TYPES = [
  { value: '', label: 'All Types' },
  { value: 'Mint', label: 'Mint' },
  { value: 'Burn', label: 'Burn' },
  { value: 'Transfer To', label: 'Transfer To' },
  { value: 'Delete', label: 'Delete' },
  { value: 'Block', label: 'Block' },
  { value: 'Unblock', label: 'Unblock' },
  { value: 'Treasury Update', label: 'Treasury Update' },
  { value: 'Reject', label: 'Reject' },
] as const
